import React from 'react';
import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import validationFormsStyle from 'assets/jss/material-dashboard-pro-react/views/validationFormsStyle';
import ReviewDetails from 'components/Review/Details';

const ScreenReviewDetails = props => {
  const { match } = props;
  return <ReviewDetails id={match.params.id} />;
};

ScreenReviewDetails.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
};

export default withStyles(validationFormsStyle)(ScreenReviewDetails);
